import { createAction, props } from '@ngrx/store';
import { HelpLink, Nuclide } from '../models';
import { Constants } from '../models/constants';

export const loadCommonStores = createAction('[CommonStore] Load CommonStores');

export const loadHelpLinks = createAction('[CommonStore] Load HelpLinks');
export const loadHelpLinksSuccess = createAction(
    '[CommonStore] Load HelpLinks Success',
    props<{ helpLinks: HelpLink[] }>()
);
export const loadConstants = createAction(
    '[CommonStore] Load Constants',
    props<{ constants: Constants }>()
);

export const loadNuclides = createAction('[CommonStore] Load Nuclides');
export const loadNuclidesSuccess = createAction(
    '[CommonStore] Load Nuclides Success',
    props<{ nuclides: Nuclide[] }>()
);
